import React from 'react';
import { DashboardLayout } from '@vette/ui-components';
import { firebase } from '@vette/frontend-utils';
import { SettingsPage } from '@vette/pages';

const Settings = () => {
  return (
    <>
      <firebase.FirebaseClaims
        required={{ id: true }}
        fallback={<DashboardLayout loading />}
      >
        {({ id }) => <SettingsPage userId={id} />}
      </firebase.FirebaseClaims>
    </>
  );
};

export default Settings;
